// 创建一个变量来存储 API 实例的 getter 函数
let getApiInstance = null;

// 提供设置 API 实例 getter 的方法
export function setApiGetter(getter) {
  getApiInstance = getter;
}

// 获取当前 API 实例的辅助函数
function getApi() {
  if (!getApiInstance) {
    throw new Error('API getter not set. Please initialize the daily module with an API instance.');
  }
  const api = getApiInstance();
  if (!api || !api.divisionOrgSalesWebApi) {
    throw new Error('Invalid API instance. Make sure the API object has dailyApi property.');
  }
  return api;
}

// 初始状态
const state = {
  relations: [],
  regions: [],
  districts: [],
  provinces: [],
  authorizedRegionsDistrictProvinces: [] // 新增结构
}

// getters
const getters = {
  relations: state => state.relations,
  regions: state => state.regions,
  districts: state => state.districts,
  provinces: state => state.provinces,
  authorizedRegionsDistrictProvinces: state => state.authorizedRegionsDistrictProvinces // 新增getter
}

// actions
const actions = {
  // 获取所有销售关系数据
  async fetchAllRelations({ commit }) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getAllRelations()
      if (response.data.success) {
        commit('setRelations', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },
  
  // 根据省份ID获取销售关系数据
  async fetchRelationByProvinceId({ commit }, provinceId) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getRelationByProvinceId(provinceId)
      if (response.data.success) {
        commit('setRelations', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },
  
  // 获取去重后的区域信息
  async fetchDistinctRegions({ commit }) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctRegions()
      if (response.data.success) {
        commit('setRegions', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },
  
  // 基于region_id获取去重后的地区信息
  async fetchDistinctDistrictsByRegionId({ commit }, regionId) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctDistrictsByRegionId(regionId)
      if (response.data.success) {
        commit('setDistricts', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },

  // 获取去重后的地区信息
  async fetchDistinctDistricts({ commit }) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctDistricts()
      if (response.data.success) {
        commit('setDistricts', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },

  // 获取去重后的省份信息
  async fetchDistinctProvinces({ commit }) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctProvinces()
      if (response.data.success) {
        commit('setProvinces', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },
  
  // 基于region_id获取去重后的省份及相关销售信息
  async fetchDistinctProvincesByRegionId({ commit }, regionId) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctProvincesByRegionId(regionId)
      if (response.data.success) {
        commit('setProvinces', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },
  
  // 基于district_id获取去重后的省份及相关销售信息
  async fetchDistinctProvincesByDistrictId({ commit }, districtId) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctProvincesByDistrictId(districtId)
      if (response.data.success) {
        commit('setProvinces', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  },
  
  // 获取完整的级联关系数据
  async fetchAuthorizedRegionsDistrictProvinces({ commit }) {
    try {
      const api = getApi();
      const response = await api.divisionOrgSalesWebApi.getDistinctRegionsDistrictsProvinces()
      if (response.data.success) {
        commit('setAuthorizedRegionsDistrictProvinces', response.data.data)
        return response.data.data
      } else {
        throw new Error(response.data.message)
      }
    } catch (error) {
      throw error
    }
  }
}

// mutations
const mutations = {
  setRelations(state, relations) {
    state.relations = relations
  },
  
  setRegions(state, regions) {
    state.regions = regions
  },
  
  setDistricts(state, districts) {
    state.districts = districts
  },
  
  setProvinces(state, provinces) {
    state.provinces = provinces
  },
  
  // 新增mutation
  setAuthorizedRegionsDistrictProvinces(state, data) {
    state.authorizedRegionsDistrictProvinces = data
  },
  
  clearRelations(state) {
    state.relations = []
  },
  
  clearRegions(state) {
    state.regions = []
  },
  
  clearDistricts(state) {
    state.districts = []
  },
  
  clearProvinces(state) {
    state.provinces = []
  },
  
  // 新增mutation
  clearAuthorizedRegionsDistrictProvinces(state) {
    state.authorizedRegionsDistrictProvinces = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}